module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg6@2x.50903ffe.png";